import clsx from "clsx";
import { useRef, useState } from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { PencilFill } from "react-bootstrap-icons";
import styles from "./EditableText.module.scss";

type Props = {
  value: string;
  onChange: (value: string) => void;
  showTooltip?: boolean;
};

export function EditableText(props: Props) {
  const [isEditingName, setIsEditingName] = useState(false);
  const inputRef = useRef<HTMLInputElement>(null);
  const [editedValue, setEditedValue] = useState<string>(
    pdfExtensionReplace(props.value),
  );

  function pdfExtensionReplace(name: string) {
    return name.replace(".pdf", "").replace(".PDF", "");
  }

  function focusAndMoveCursorToEnd() {
    if (inputRef.current) {
      inputRef.current.focus();
      // Move cursor to end
      const length = inputRef.current.value.length;
      inputRef.current.setSelectionRange(length, length);
      // Scroll to end to show the cursor
      inputRef.current.scrollLeft = inputRef.current.scrollWidth;
    }
  }

  function handleInputBlur() {
    if (isEditingName) {
      setIsEditingName(false);
      if (editedValue !== pdfExtensionReplace(props.value)) {
        props.onChange(editedValue);
      }
    }
  }

  function handlePencilClick() {
    setIsEditingName(true);
    // Use setTimeout to ensure the input is ready after state update
    setTimeout(() => {
      focusAndMoveCursorToEnd();
    }, 0);
  }

  function handleInputKeyDown(event: React.KeyboardEvent<HTMLInputElement>) {
    if (event.key === "Enter") {
      if (isEditingName) {
        inputRef.current?.blur();
      } else {
        setIsEditingName(true); //allow keyboard usage
      }
    }
  }
  return (
    <OverlayTrigger
      placement="top"
      delay={{ show: 1000, hide: 50 }}
      overlay={<Tooltip>{editedValue}</Tooltip>}
      show={props.showTooltip}
    >
      <div className={clsx(styles.documentNameContainer, styles.cellData)}>
        <input
          data-testid="document-name-input"
          ref={inputRef}
          value={editedValue}
          onChange={(e) => setEditedValue(e.target.value)}
          onBlur={handleInputBlur}
          onKeyDown={handleInputKeyDown}
          readOnly={!isEditingName}
          type="text"
          className={clsx(styles.documentNameInput, {
            [styles.editing]: isEditingName,
          })}
        />
        {!isEditingName && (
          <PencilFill
            onClick={handlePencilClick}
            className={clsx("cursor-pointer", styles.pencilIcon)}
          />
        )}
      </div>
    </OverlayTrigger>
  );
}
